export function mainBannerAnimation() {
    const benefits = document.querySelector('.main-banner-info-benefits--js');
    if (benefits) {
        window.addEventListener('scroll', setOpacity);
        setOpacity();
        function setOpacity() {
            const benefitsBox = benefits.getBoundingClientRect();
            const benefitsDocumentY = window.scrollY + benefitsBox.y;
            const opacityValue = 1 - Math.min((benefitsDocumentY - benefitsBox.y) / (window.innerHeight * 0.9), 1);
            benefits.style.opacity = opacityValue;
        }
    }
}
